import FilterForm from '../../components/forms/FilterForm';
import useToggle from '../../hooks/useToggle';
import { CreateCourseModal } from '../../components/modal/courses/CreateCourseModal';
import { CrudFilters, HttpError, useCan } from '@refinedev/core';
import {
  EditButton,
  ShowButton,
  TagField,
  TextField,
  useTable
} from '@refinedev/antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';
import { Flex, Form, Input, Space, Table } from 'antd';
import { ICourse } from 'interfaces/courses';
import { IInstructor } from 'interfaces/instructors';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { formatDate } from 'services/date';

interface IFilter {
  name: string;
}

export const CourseList = () => {
  const { value: isOpen, set: setIsModalOpen } = useToggle();
  const { data: canCreate } = useCan({
    resource: 'courses',
    action: 'create'
  });
  const { tableProps, searchFormProps } = useTable<ICourse, HttpError, IFilter>(
    {
      onSearch: params => {
        const filters: CrudFilters = [];
        const { name } = params;

        filters.push({
          field: 'filter[name]',
          operator: 'eq',
          value: name
        });

        return filters;
      },
      sorters: {
        mode: 'server'
      }
    }
  );

  return (
    <ListLayout
      title="Cursos avulsos"
      canCreate={Boolean(canCreate?.can)}
      createButtonProps={{
        onClick: () => setIsModalOpen(true)
      }}
    >
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input
            placeholder="Buscar por nome do curso"
            className="min-w-[300px]"
            suffix={<SearchOutlined />}
          />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id" tableLayout="fixed">
        <Table.Column
          dataIndex="name"
          key="name"
          width={200}
          title="Nome"
          fixed="left"
          sorter
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="duration_in_hours"
          key="duration_in_hours"
          title="Duração (horas)"
          width={50}
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="kind"
          key="kind"
          title="Tipo"
          width={80}
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="instructors"
          key="instructors"
          title="Instrutores"
          width={250}
          render={instructors => {
            return (
              <Flex wrap="wrap" gap={6}>
                {instructors.map((instructor: IInstructor) => (
                  <TagField
                    key={instructor.id}
                    value={instructor.name}
                    className="mr-0"
                  />
                ))}
              </Flex>
            );
          }}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title="Criado em"
          width={100}
          sorter
          render={value => (
            <TextField value={formatDate(value, 'DD/MM/YYYY')} />
          )}
        />
        <Table.Column
          dataIndex="updated_at"
          key="updated_at"
          title="Última atualização"
          width={100}
          sorter
          render={value => (
            <TextField value={formatDate(value, 'DD/MM/YYYY')} />
          )}
        />
        <Table.Column<ICourse>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          fixed="right"
          render={(_, record) => {
            return (
              <Space>
                <ShowButton
                  hideText
                  size="small"
                  recordItemId={record.id}
                  icon={<EyeOutlined />}
                  accessControl={{ hideIfUnauthorized: true }}
                />
                <EditButton
                  hideText
                  size="small"
                  recordItemId={record.id}
                  accessControl={{ hideIfUnauthorized: true }}
                />
              </Space>
            );
          }}
        />
      </Table>
      {canCreate?.can && (
        <CreateCourseModal open={isOpen} onClose={setIsModalOpen} />
      )}
    </ListLayout>
  );
};
